module.exports = __webpack_public_path__ + "static/media/path08.ebd2400b.png";